'use strict'
import { App, Controller, Controllers, Router, View } from '../config/app.js'
import { currentUser, hasRole, getError, loginRedirectUrl } from '../helper.js'

class DefaultController extends Controller
{
	async index()
	{
		document.body.setAttribute('data-controller', 'Home')

		const viewFeaturedCategories = View.create({ name: 'default/featuredCategories', model: {} })
		const viewFeaturedProducts = View.create({ name: 'default/featuredProducts', model: {} })

		App.Store.fetch('category', 0,
			{
				'filter[featured]': true,
				'u': App.Config.customerId
			})
			.then(m => viewFeaturedCategories.model.sync(m))

		App.Store.fetch('product', 0,
			{
				'filter[featured]': true,
				'include': ['image', 'promotion', 'price', 'variant'],
				'u': App.Config.customerId
			})
			.then(m => viewFeaturedProducts.model.sync(m))

		if (Handlebars.helpers.isPecomStore())
		{
			View.create({
				name: 'default/cart'
			})
			this.cart()
		}

		this.view.render()
	}

	async contact()
	{
		//#region Form data
		let data =
		{
			fullName: '',
			email: '',
			phone: ''
		}

		if (Helper.hasRole('Registered'))
		{
			const customer = Handlebars.helpers.currentUser()
			let address = null
			if (customer?.relationships?.address?.data?.id)
				address = App.Store.model('address', customer.relationships.address.data.id)
			if (address)
			{
				data.fullName = [address.attributes.firstName, address.attributes.lastName].join(' ')
				data.email = address.attributes.email
				data.phone = address.attributes.phone
			}
			else
			{
				data.fullName = [customer.attributes.firstName, customer.attributes.lastName].join(' ')
				data.email = customer.attributes.email
			}
		}
		//#endregion Form data

		//#region Contact Us Topic
		const topicId = Handlebars.helpers.isApexStore() ? 'ContactUs' : 'ContactUsPatients'
		const topicViewName = Handlebars.helpers.isApexStore() ? 'topic/contactUs' : 'topic/contactUsPatients'

		View.create(
		{
			name: topicViewName,
			file: 'partial/topic',
			model: App.Store.modelCreate('topic', topicId)
		})

		App.Store.fetch('topic', topicId).catch(() => { })
		//#endregion Contact Us Topic

		this.view.model.sync(data)
	}

	async cart()
	{
		this.view.render()

		if (!hasRole('Guest'))
		{
			App.Store
				.fetch('cartitem')
				.catch(error => App.Component.HandleErrors(error)) // Prevent logging of 'No data found' while maintaining customer error messaging
		}

		//#region Shipping Promo Topic
		const topicId = hasRole(App.Roles.Practitioner) ? 'Order.ShippingPromo.Practitioner' :
			currentUser().attributes.hasOrdered ? 'Order.ShippingPromo' : 'Order.ShippingPromo.PatientFirst'
		View.create({
			name: 'topic/shippingPromo',
			file: 'partial/topic',
			model: App.Store.modelCreate('topic', topicId)
		})
		App.Store.fetch('topic', topicId).catch(_ => { })
		//#endregion Shipping Promo Topic
	}

	async sitemap()
	{
		return App.Store.fetch('sitemap')
			.then(m =>
			{
				this.view.model.sync(m)
			})
			.catch(error =>
			{
				App.Component.HandleErrors(error)
				this.view.render()
			})
	}

	async storeclosed()
	{
		const store = App.Store.model('store', App.Config.storeId)
		if (!store.attributes.closed)
			Router.navigate('/')

		return App.Store.fetch('topic', hasRole('Patient') ? 'StoreClosed.Pecom' : 'StoreClosed')
			.then(m =>
			{
				this.view.model.sync(m)
				const timer = window.setInterval(function ()
				{
					App.Store.fetch('store', 'current', { 'nocache': (new Date()).toISOString() })
						.then(store =>
						{
							if (!store.attributes.closed)
							{
								window.clearInterval(timer)
								Router.navigate('/')
							}
						})
				}, 60000)
			})
			.catch(error =>
			{
				App.Component.HandleErrors(error)
				this.view.render()
			})
	}

	async login()
	{
		if (Handlebars.helpers.isApexStore())
			await App.Store.fetch('topic', 'NewAccountApplication')
		this.view.render()
	}

	async __autoload()
	{
		const urlRecord = await App.Store.fetch('urlrecord', this.view.model.method,
			{
				'include':
					[
						'entity',
						'category.*',
						'topic.*',
						'product.child',
						'product.child.*',
						'product.image',
						'product.thumbnail',
						'product.price',
						'product.promotion',
						'product.specification',
						'product.variant',
						'product.breadcrumb',
						'product.category',
						'product.related',
						'product.related.image',
						'product.related.price',
						'product.related.promotion',
						'product.related.variant',
						'product.alsopurchased',
						'product.alsopurchased.image',
						'product.alsopurchased.price',
						'product.alsopurchased.promotion',
						'product.alsopurchased.variant',
						'product.header',
						'product.suggesteduse',
						'product.supplementfacts',
						'product.detail'
					]
			})

		const entity = urlRecord?.relationships?.entity?.data

		if (entity)
		{
			this.view.file = this.view.model.controller + '/' + entity.type
			this.view.model.sync(
				{
					method: entity.type,
					view: this.view.file,
					data:
					{
						id: entity.id,
						slug: urlRecord.id,
						type: entity.type
					}
				})

			if (entity.type == 'categorydetail' && App.Store.model(entity.type, entity.id)?.attributes?.productCount)
			{
				let include = Helper.hasRole('Registered')
					? ['image', 'variant', 'price', 'promotion']
					: ['image', 'variant']

				App.Store.page('product', 1, 9, { 'filter[category]': entity.id, include: include.join(',') })
			}
		}

		this.view.render()
	}

	async __error()
	{
		const error = getError(this.view.model.error)
		if (error.status == 404 || (error.status == 403 && Helper.hasRole('Guest'))) //NotFound
		{
			return App.Store.fetch('topic', 'PageNotFound')
				.then(m =>
				{
					this.view.file = this.view.model.controller + '/topic'
					this.view.model.sync(
						{
							method: 'topic',
							view: this.view.file,
							data:
							{
								id: 'PageNotFound',
								slug: 'pagenotfound',
								type: 'topic'
							}
						})
				})
				.catch(error =>
				{
					App.Component.HandleErrors(error)
					this.view.render()
				})
		}
		else if (error.status == 403) //Forbidden
		{
			location.href = loginRedirectUrl()
			return
		}
		
		this.view.render()
	}
}

export { DefaultController }
